import { VatDetails } from '~/types/vat'
import { ApiKy } from './index'

export default class Api extends ApiKy {
  check(vatNumber: string) {
    return this.ky.get(`${this.url}/${vatNumber}`)?.json<VatDetails>()
  }
}
